import { cn } from "@/lib/utils";
import React from "react";

interface ScoreBadgeProps {
  score: number;
  thresholds?: {
    green: number;
    yellow: number;
  };
  className?: string;
}

const ScoreBadge: React.FC<ScoreBadgeProps> = ({
  score,
  thresholds = { green: 90, yellow: 70 },
  className = "",
}) => {
  const { green, yellow } = thresholds;

  const statusClass = cn(
    "size-6 rounded-full flex items-center justify-center text-black font-semibold ring-1 ring-offset-1 dark:ring-offset-background",
    score >= green &&
      "bg-green-200 ring-green-400 dark:bg-green-500 dark:ring-green-400",
    score >= yellow &&
      score < green &&
      "bg-yellow-200 ring-yellow-400 dark:bg-yellow-500 dark:ring-yellow-400",
    score < yellow &&
      "bg-red-200 ring-red-400 dark:bg-red-500 dark:ring-red-400",
    className
  );

  return (
    <div className={statusClass}>
      <span>{Math.min(Math.round(score), 100)}</span>
    </div>
  );
};

export default ScoreBadge;
